"use strict";

exports.__esModule = true;
exports.default = exports.getTime = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  time: {
    fontFamily: "Akkurat Mono, monospace",
    fontSize: "14px",
    lineHeight: 1,
    marginTop: theme.spacing(.25)
  },
  progress: {
    flexGrow: 1,
    margin: theme.spacing(0, 2)
  }
}));

const getTime = timeInSeconds => {
  var pad = function pad(num, size) {
    return ('000' + num).slice(size * -1);
  },
      time = parseFloat(timeInSeconds).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60),
      milliseconds = time.slice(-3); //    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2) + ',' + pad(milliseconds, 3);


  if (hours) {
    return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2);
  }

  return minutes + ':' + pad(seconds, 2);
};

exports.getTime = getTime;

const MediaTimeControls = ({
  className,
  buffered,
  duration = 0,
  currentTime = 0,
  onChange
}) => {
  const classes = useStyles();
  const timePlayed = getTime(currentTime);
  const timeTotal = getTime(duration);

  const handleChange = (event, value) => {
    onChange && onChange(value);
  };

  return _react.default.createElement("div", {
    className: className || classes.root
  }, _react.default.createElement("div", {
    className: classes.time
  }, timePlayed), _react.default.createElement(_Slider.default, {
    className: classes.progress,
    min: 0,
    max: duration,
    value: currentTime,
    onChange: handleChange
  }), _react.default.createElement("div", {
    className: classes.time
  }, timeTotal));
};

var _default = MediaTimeControls;
exports.default = _default;